import { MessageType } from "../gateways/MessageGateway";

export interface Order {
    orderNumber: string;
    userId: string | null;
    firstName: string;
    lastName: string;
    email: string | null;
    phoneNumber: string;
    cartItems: OrderCartItem[]; // You can define a more specific type if needed
    subtotal: string;
    vatAmount: string;
    deliveryFee: string;
    totalAmount: string;
    totalPaid: string;
    deliveryLocation: string;
    comments: string;
    createdAt: string; // ISO string format for timestamps
    updatedAt?: string; // ISO string format for timestamps
    status: string; // Define possible statuses if needed
    messagePreference: MessageType;
    paymentMethod: PaymentType;
    finalPaymentMethod: string;
}

export interface FireStoreOrder {
    id: string;
    order: Order
}

export interface OrderCartItem {
    id: string,
    name: string,
    quantity: number,
    priceAfterTax: string,
    priceBeforeTax: string,
    attributes: { [key: string]: string };
    imageUrl: string,
}

export enum PaymentType {
    Credit = "credit",
    NotApplicable = "na",
    OnCollection = "on-collection"
}
